export enum EAiModelType {
  Yolo,
}
